jQuery('.search-field').focus(function (e) {
    jQuery('#search').addClass("expand-search");
    e.preventDefault();
});

jQuery('#fake-search').on('click', function () {
    jQuery("#search-field").addClass("expand-search");
    jQuery("#search-field").focus();
    jQuery("button[type=submit]").css("display", "block");
    jQuery('#fake-search').hide();
});